import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    CardMedia,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { uri } from "../../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";
// import { SearchCloseReports } from "../../../../../services/accMasn-services";
import { sto } from "../../../../Context/InshData";
import Image from "../../../../assets/img/VAT.svg";
import VatReportsOneTableSale from "./VatReportsOneTableSale";
import VatReportsOneForm from "./VatReportsOneForm";
import VatReportsOneTablePurch from "./VatReportsOneTablePurch";
import VatReportsOneTableVat from "./VatReportsOneTableVat";


const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(1),

    },
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: "#d3d3d3",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#d3d3d3",
        borderColor: "#808080",
    },
    paperContainer: {
        backgroundImage: `url(${Image})`,
    },
    logo: {
        margin: 'auto',
        width: '100%',
        minHeight:'500px',
        backgroundSize: 'cover',
    },
    rootCaedL: {
        maxWidth: 500,
        maxHeight: 600,
        // boxShadow:'0px 0px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
        boxShadow: 'none',
        // paddingTop: '100px',
        textAlign: 'center'
        // borderRadius: '0.5rem',
    },
}));

export default function VatReportsOne(props) {
    const { AutoOptions } = props;

    const typeSearch = [
        { id: 0, name: "الكل" ,label:"transAll"},
        { id: 1, name: "خاضعة للضريبة",label:"WithVat" },
        { id: 2, name: "غير خاضعة للضريبة",label:"WithoutVat" },
      ];
    const SearchCloseReports = {
        dateFrom: moment(new Date()).format('YYYY-MM-DD'),
        timeFrom: moment(new Date()).format('HH:mm'),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).format('HH:mm'),
        branch: AutoOptions?.Branches[0],
        typeSearch: typeSearch[0]
    };
    const [rptParams, setRptParams] = React.useState(SearchCloseReports);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [sum, setSum] = useState(false);
    const { t } = useTranslation(["forms", "translation"]);

    const viewHandle = async () => {

        setData([]);
        setFetching(true);
        await axios
            .get(
                uri +
                `AccountReports/rptTax?branch=${rptParams?.branch?.id}
                &&dateF=${rptParams?.dateFrom + ' ' + rptParams.timeFrom}
        &&dateT=${rptParams?.dateTo + ' ' + rptParams.timeTo}
        &&type=${rptParams.typeSearch?.label}`
            )
            .then((res) => {
                setData(res.data);
                console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                setFetching(false);
                console.log(err);
                // toast.err("يوجد خطأ في الجلب");
                setData([]);
            });
    };
    const his = useHistory();
    const printHandle = () => {
        if (data.lenght == 0) {
            alert("لاتوجد بيانات");
        } else {
            const info = {
                data: data,
                from: "one",
                title: ' تقرير الاقرار الضريبي',
                branch: rptParams.branch.name,
                fDate: rptParams.dateFrom,
                tDate: rptParams.dateTo,
                nDate: moment(new Date()).format('YYYY-MM-DD'),
                // totsp:rpt.totSelcPeriod,balncsp:rpt.balncSelcPeriod
            }
            localStorage.setItem("iInfos", JSON.stringify(info));
            his.push({ pathname: "/VatReportOne" });
            window.location.reload(true);
        }
    };

    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });

        prop == 'dateFrom' ? rptParams.dateFrom = e.target.value : rptParams.dateTo = e.target.value
    };
    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
    };
    const styles = {
        paperContainer: {
          backgroundImage: `url(${Image})`,
        },
      };
    const ContLeft_ = () => {
        return (
            <Grid container item>
                <Grid lg={12} md={12} sm={12} xs={12} item>
                    <Card className={classes.rootCaedL}>
                        <CardMedia
                            className={classes.logo}
                            style={styles.paperContainer}
                        ></CardMedia>
                    </Card>
                </Grid>
            </Grid>
        );
    };

    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    style={{ backgroundColor: "#d3d3d3", fontWeight: "bold" }}
                    color="primary"
                >
                    {" تقرير الاقرار الضريبي "}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip}>

                    <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip}>

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <VatReportsOneForm
                                {...{
                                    AutoOptions,
                                    rptParams,
                                    onChangeData,
                                    onChangeAutoData,
                                    changTField,
                                    typeSearch
                                }}
                            />
                            <Grid
                                item
                                container

                                justifyContent="center"
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                spacing={1}
                            >
                                <Hidden smUp={["sm"]}>

                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<ScannerIcon />}
                                            size="large"
                                            style={
                                                (inshst.sal.iconBtnAcc,
                                                    { borderRadius: 0 })
                                            }
                                            className={[clasui.buttonAcc]}
                                            onClick={() => viewHandle()}
                                        >
                                            {t("forms:show")}
                                        </Button>
                                    </Grid>
                                </Hidden>
                                <Hidden only={["xs"]}>

                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<ScannerIcon />}
                                            size="large"
                                            style={
                                                (inshst.sal.iconBtnAcc,
                                                    { borderRadius: 0 })
                                            }
                                            className={[clasui.buttonAcc]}
                                            onClick={() => viewHandle()}
                                        >
                                            {t("forms:view")}
                                        </Button>
                                    </Grid>
                                </Hidden>

                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<PrintIcon />}
                                        color="primary"
                                        size="large"
                                        style={
                                            (inshst.sal.iconBtnAcc,
                                                { borderRadius: 0 })
                                        }
                                        className={[clasui.buttonAcc]}
                                        onClick={printHandle}
                                    >
                                        {t("forms:print")}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        startIcon={<KeyboardReturnSharpIcon />}
                                        color="secondary"
                                        size="large"
                                        className={[clasui.button, clasSp.clcan]}
                                        style={
                                            (inshst.sal.iconBtn,
                                                { borderRadius: 0 })
                                        }
                                        onClick={() => his.goBack()}
                                    >
                                        {t("forms:exit")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Container>
                        <Grid container item lg={12} md={12} sm={12} xm={12}>
                            <Grid container item lg={9} md={9} sm={12} xm={12}>

                                <Container
                                    component={Paper}
                                    maxWidth={false}
                                    style={{
                                        padding: "10px",
                                        marginTop: "0.5rem",
                                        marginBottom:"0.2rem"
                                    }}
                                >
                                    <Grid container justifyContent="center">
                                        <Grid item container justifyContent="center" xs={12}>
                                            <BeatLoader loading={fetching} color="#d3d3d3" />
                                            {!fetching && (
                                                <VatReportsOneTableSale
                                                    {...{
                                                        data: data ? data : [],
                                                        isPrint:false,
                                                    }}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Container>
                                <Container
                                    component={Paper}
                                    maxWidth={false}
                                    style={{
                                        padding: "10px",
                                        marginTop: "0.5rem"
                                    }}
                                >
                                    <Grid container justifyContent="center">
                                        <Grid item container justifyContent="center" xs={12}>
                                            <BeatLoader loading={fetching} color="#d3d3d3" />
                                            {!fetching && (
                                                <VatReportsOneTablePurch
                                                    {...{
                                                        data: data ? data : [],
                                                        isPrint:false,
                                                    }}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Container>
                                <Container
                                    component={Paper}
                                    maxWidth={false}
                                    style={{
                                        padding: "10px",
                                        marginTop: "0.5rem"
                                    }}
                                >
                                    <Grid container justifyContent="center">
                                        <Grid item container justifyContent="center" xs={12}>
                                            <BeatLoader loading={fetching} color="#d3d3d3" />
                                            {!fetching && (
                                                <VatReportsOneTableVat
                                                    {...{
                                                        data: data ? data : [],
                                                        isPrint:false,
                                                    }}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Container>
                            </Grid>
                            <Grid container item lg={3} md={3} sm={3} xm={12}>
                            <Container
                                    component={Paper}
                                    maxWidth={false}
                                    style={{
                                        padding: "10px",
                                        marginTop: "0.5rem"
                                    }}
                                >
                                <Hidden smDown={["sm"]}>
                                <ContLeft_ />

                                </Hidden>
                                </Container>
                            </Grid>

                        </Grid>


                    </Grid>


                </Grid>
            </Typography>
        </div>
    );
}
